import React from "react"

interface Teaser {
  headline: string
  preamble: string
  linkUrl?: string
  image: {
    asset: {
      url
    }
  }
}

export default ({ headline, preamble, linkUrl, image }: Teaser) => {
  const isArticleTeaser = !!linkUrl
  return (
    <div
      className={isArticleTeaser ? "teaser teaser--article" : "teaser"}
      key={`teaser-${headline}`}
    >
      <div className="teaser__image-wrapper">
        <img src={image.asset.url} />
      </div>
      <div className="teaser__text">
        <h2>{headline}</h2>
        <p>{preamble}</p>

        {linkUrl && (
          <a href={linkUrl} className="teaser__link" target="blank">
            Read Article
          </a>
        )}
      </div>
    </div>
  )
}
